import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { defaults } from "chart.js";
import { tooltip } from "leaflet";
import Button from "../../../shared/Button";
import "chart.js/auto";

defaults.font.family = "'Yekan', 'sans-serif'";
defaults.font.size = 16;
defaults.font.weight = 700;
defaults.color = "#292D32";
defaults.borderColor = "#fff";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  elements: {
    point: {
      borderWidth: 0,
      radius: 0,
      backgroundColor: "rgba(0,0,0,0)"
    }
  },
  scales: {
    scaleOverride: true,

    y: {
      position: "right",
      border: {
        display: true
      },

      grid: {
        tickWidth: 0,
        color: "#F0F5F7",
        alignToPixels: true
      }
    },
    x: {
      border: {
        display: true
      },
      grid: {
        tickWidth: 0,
        color: "#F0F5F7",
        alignToPixels: true
      }
    }
  },
  plugins: {
    legend: {
      position: "top",
      display: false,
      labels: {
        usePointStyle: true, //for style circle
        font: {
          family: "'Yekan', 'sans-serif'",
          size: 14,
          weight: "normal"
        }
      }
    },

    tooltip: {
      bodyFont: {
        family: "'Yekan', 'sans-serif'", // Add your font here to change the font of your tooltip body
        size: 16
      },
      titleFont: {
        family: "'Yekan', 'sans-serif'",
        size: 16 // Add your font here to change the font of your tooltip title
      }
    }
  }
};

const labels = [
  "اسفند",
  "بهمن",
  "دی",
  "آذر",
  "آبان",
  "مهر",
  "شهریور",
  "مرداد",
  "تیر",
  "خرداد",
  "اردبیهشت",
  "فروردین"
];

export function YourIncome({ StatisticInfo }) {
  const canvas = document.createElement("canvas");
  const [incomeData, setincomeData] = useState([0,0,0,0,0,0,0,0,0,0,0,0]);
  useEffect(() => {}, []);
  const getmonth = m => {
    const arr = m.split("-");
    const mo = arr[1];
    let monthname;
    switch (mo) {
      case "01":
        return "فروردین";
        break;
      case "02":
        return "اردبیهشت";

        break;

      case "03":
        return "خرداد";
        break;

      case "04":
        return "تیر";
        break;

      case "05":
        return "مرداد";
        break;

      case "06":
        return "شهریور";
        break;
      case "07":
        return "مهر";
        break;
      case "08":
        return "آبان";

        break;

      case "09":
        return "آذر";
        break;

      case "10":
        return "دی";
        break;

      case "11":
        return "بهمن";
        break;

      case "12":
        return "اسفند";
        break;
      default:
        break;
    }
    return monthname;
  };

  useEffect(() => {
    for (let x of StatisticInfo.monthly_income) {
      for (let y in labels) {
        //console.log(labels[y], y);
        if (labels[y] === getmonth(x.date)) {
          console.log(labels[y], y, x.income);

          setincomeData(datas => ({
            ...datas,
            [y]: x.income
          }));
        }
      }
    }
  }, []);

  const getData = canvas => {
    const ctx = canvas.getContext("2d");
    const gradient = ctx.createLinearGradient(0, 0, 0, 270);
    gradient.addColorStop(0.5, "rgba(244, 142, 47, 0.1)");
    gradient.addColorStop(1, "#efefef");

    return {
      labels,

      datasets: [
        {
          label: "رد شده ",
          type: "bar",
          data: Object.values(incomeData),
          backgroundColor: "#00A6A6",
          borderRadius: 12,
          width: 37,
          borderSkipped: false
        },
        {
          label: "Expenses",
          type: "line",
          data: Object.values(incomeData),
          fill: true,
          borderColor: "#F48E2F",
          borderWidth: 3,
          lineTension: 0.5,
          backgroundColor: gradient
        }
      ]
    };
  };
  const chartData = getData(canvas);
  console.log(Object.values(incomeData));
  return (
    <div className="ReserveCounts">
      <div>
        <div className="d-flex-space mb-[47px]">
          <div className="d-flex gap-[24px]">
            <h3 className="UserStatics--h3">درآمد شما</h3>
          </div>
          <div className="gray-bg">ماهیانه</div>
        </div>
      </div>
      <Bar
        datasetIdKey="label"
        options={options}
        data={chartData}
        id="myChart"
        style={{ fontFamily: "'Yekan', 'sans-serif'" }}
      />
    </div>
  );
}

export default YourIncome;
